import { CustomSelect } from '@/components';
import { Row } from '@/components/SettingsLayout';
import {
  CompaniesCount,
  OrgFilter,
  useGetAllOrganizationQuery,
} from '@/store/slices/organizationsSlice';
import { Input } from '@/ui';
import styles from '../styles.module.css';
import { useTranslation } from 'react-i18next';
import { usePaginationFilter } from '@/hooks/usePaginationFilter';
import { SelectOption } from '@/types/types';
import { useMemo } from 'react';
import { useGetUser } from '@/hooks';
import { CompanyTypes } from '@/types';
import { skipToken } from '@reduxjs/toolkit/query/react';

const CompaniesFilter = ({
  handleChange,
}: {
  handleChange: (name: string, value: any) => void;
}) => {
  const { t } = useTranslation();
  const { currentUser, company } = useGetUser();
  const { filter } = usePaginationFilter<OrgFilter>({
    search: '',
    limit: 100,
    offset: 0,
    type: CompanyTypes.ORGANIZATION,
    organizationId: currentUser.companyId,
  });
  const { data } = useGetAllOrganizationQuery(
    company?.type === CompanyTypes.ROOT && company?._id
      ? {
          id: company._id,
          filter,
        }
      : skipToken,
  );

  const organizationOptions = useMemo(() => {
    if (data && data.data.length > 0) {
      return data?.data.map((org) => ({
        label: org.name,
        value: org._id,
      }));
    } else {
      return [];
    }
  }, [data]);

  return (
    <Row fullWidth justify='justify-between'>
      <Row gapSize='12' fullWidth={false}>
        <div className={styles.filterContainer}>
          <CustomSelect
            onChange={(value: SelectOption) => handleChange('numberOfOutlets', value.value)}
            options={[
              {
                label: t('Companies.all_outlets'),
                value: CompaniesCount.ALL,
              },
              {
                label: t(`Companies.${CompaniesCount.TEN}`),
                value: CompaniesCount.TEN,
              },
              {
                label: t(`Companies.${CompaniesCount.FIFTY}`),
                value: CompaniesCount.FIFTY,
              },
              {
                label: t(`Companies.${CompaniesCount.HUNDRED}`),
                value: CompaniesCount.HUNDRED,
              },
              {
                label: t(`Companies.${CompaniesCount.HUNDRED_PLUS}`),
                value: CompaniesCount.HUNDRED_PLUS,
              },
            ]}
            defValue={{
              label: t('Companies.all_outlets'),
              value: CompaniesCount.ALL,
            }}
            menuPosition='fixed'
          />
        </div>
        {company?.type === CompanyTypes.ROOT && (
          <div className={styles.filterContainer}>
            <CustomSelect
              onChange={(value: SelectOption) => handleChange('organizationId', value.value)}
              options={organizationOptions}
              defValue={organizationOptions[0]}
            />
          </div>
        )}
      </Row>
      <Row fullWidth={false}>
        <div className={styles.searchInput}>
          <Input
            variant='search'
            placeholder={t('Companies.search_text')}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChange('search', e.target.value)
            }
          />
        </div>
      </Row>
    </Row>
  );
};

export default CompaniesFilter;
